import React from "react";
import { ReactComponent as ArchiveIcon } from "assets/svgFonts/archive.svg";
import { ReactComponent as DeleteIcon } from "assets/svgFonts/delete.svg";
import { ReactComponent as DraftsIcon } from "assets/svgFonts/drafts.svg";
import { ReactComponent as DriveFileMoveIcon } from "assets/svgFonts/drive_file_move.svg";
import { ReactComponent as LabelIcon } from "assets/svgFonts/label.svg";
import { ReactComponent as MarkEmailUnreadIcon } from "assets/svgFonts/mark_email_unread.svg";
import { ReactComponent as UnarchiveIcon } from "assets/svgFonts/unarchive.svg";
import { ReactComponent as InboxIcon } from "assets/svgFonts/inbox.svg";

const ICON_MAP = {
  archive: ArchiveIcon,
  delete: DeleteIcon,
  drafts: DraftsIcon,
  drive_file_move: DriveFileMoveIcon,
  label: LabelIcon,
  mark_email_unread: MarkEmailUnreadIcon,
  unarchive: UnarchiveIcon,
  inbox: InboxIcon,
};

export default function EmailActionIcon({
  name,
  className = "",
  style = {},
  color,
  ...rest
}) {
  const IconComponent = ICON_MAP[name];

  if (!IconComponent) {
    return null;
  }

  const mergedStyle = {
    fill: color || "currentColor",
    ...style,
  };

  return <IconComponent className={className} style={mergedStyle} {...rest} />;
}
